<div class="form-group" *ngIf="questionModel.visible !== false">
  <div class="custom-control-wrapper" [formGroup]="form"
       [ngClass]="{'form-control-without-error' : !hasErrors(),
        'form-control-with-error' : hasErrors()}">
    <div
      class="sd-element__title sd-question__title sd-question__title--answer sd-question__title--required sd-title"
      *ngIf="questionModel.title">
      <p class="mb-0" [ngClass]="{'pb-3' : !questionModel.description}">
        <span>{{ questionModel.title }}</span>
        <span class="required-control" *ngIf="questionModel.isRequired">*</span>
      </p>
      <div class="sd-question__description--under-input" *ngIf="questionModel.description">
        <span class="sv-string-viewer question-hint" style="position: static;">{{ questionModel.description }}</span>
      </div>
    </div>
    <input
      [required]="required"
      [placeholder]="questionModel.placeholder || ''"
      [max]="maxNumber"
      [min]="minNumber"
      *ngIf="!prefix && !suffix && !questionModel.mask"
      class="form-control sd-input sd-text"
      [formControlName]="questionModel.controlName!"
      (blur)="control?.markAsUntouched()">
    <input
      *ngIf="prefix && !suffix && questionModel.mask"
      [placeholder]="questionModel.placeholder"
      [mask]="questionModel.mask"
      [prefix]="prefix"
      [required]="required"
      [dropSpecialCharacters]="false"
      class="form-control sd-input sd-text"
      [formControlName]="questionModel.controlName!"
      (blur)="control?.markAsUntouched()"
      [min]="maskMin || minNumber">
    <input
      *ngIf="!prefix && suffix && questionModel.mask"
      [placeholder]="questionModel.placeholder"
      [mask]="questionModel.mask"
      [dropSpecialCharacters]="false"
      [suffix]="suffix"
      [thousandSeparator]="thousandSeparator"
      [required]="required"
      class="form-control sd-input sd-text"
      [formControlName]="questionModel.controlName!"
      (blur)="control?.markAsUntouched()"
      [min]="maskMin || minNumber">
    <input
      *ngIf="!prefix && !suffix && questionModel.mask"
      [placeholder]="questionModel.placeholder"
      [mask]="questionModel.mask"
      [thousandSeparator]="thousandSeparator"
      [dropSpecialCharacters]="false"
      [required]="required"
      class="form-control sd-input sd-text"
      [formControlName]="questionModel.controlName!"
      (blur)="control?.markAsUntouched()"
      [min]="maskMin || minNumber">
    <ng-content></ng-content>
  </div>

  <div class="sd-element__erbox sd-error sd-question__erbox sd-question__erbox--below-question" *ngIf="hasErrors()">
    <div class="sd-question__erbox-message">
      {{ getErrorMessage() }}
    </div>
  </div>

</div>

<!--[max]="maskMax || maxNumber"-->
